type Params = {
    threshold: number;
};

export default function useOnScrolledPastThreshold(params: Params = { threshold: 150 }) {
    return (callback?: (e: React.UIEvent<HTMLElement, UIEvent>) => void) => {
        if (!callback) {
            return;
        }

        return (e: React.UIEvent<HTMLElement, UIEvent>) => {
            const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
            if (scrollHeight - scrollTop - clientHeight < params.threshold) {
                callback(e);
            }
        };
    };
}
